import React from 'react'
import './BusinessAdvantagesCard.scss'

const BusinessAdvantagesCard = ({img, text}) => {
  return (
    <div className='businessAdvantagesCard_block'>
      <span className="businessAdvantagesCard_icon" aria-hidden="true">
        <img src={img} alt="" />
      </span>
      <p>{text}</p>
    </div>
  )
}

export default BusinessAdvantagesCard
